/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReceiptPositionDto } from './GetReceiptPositionDto';
import {
    GetReceiptPositionDtoFromJSON,
    GetReceiptPositionDtoFromJSONTyped,
    GetReceiptPositionDtoToJSON,
} from './GetReceiptPositionDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetReceiptDto
 */
export interface GetReceiptDto {
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetReceiptDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    receiptType?: GetReceiptDtoReceiptTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof GetReceiptDto
     */
    receiptDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    paymentMethod?: GetReceiptDtoPaymentMethodEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    examId?: string | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetReceiptDto
     */
    exam?: GetExamDto;
    /**
     * 
     * @type {Array<GetReceiptPositionDto>}
     * @memberof GetReceiptDto
     */
    receiptPositions?: Array<GetReceiptPositionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetReceiptDto
     */
    fiscalized: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    efiscalJws?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    efiscalPmno?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    efiscalVisualizationBase64?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetReceiptDto
     */
    efiscalReceivedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    printerUid?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetReceiptDto
     */
    jpkId?: number | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetReceiptDto
     */
    creator?: GetUserDto;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptDto
     */
    printerJpkDocumentId?: string | null;
}


/**
 * @export
 */
export const GetReceiptDtoReceiptTypeEnum = {
    Fiscal: 'Fiscal',
    EFiscal: 'EFiscal'
} as const;
export type GetReceiptDtoReceiptTypeEnum = typeof GetReceiptDtoReceiptTypeEnum[keyof typeof GetReceiptDtoReceiptTypeEnum];

/**
 * @export
 */
export const GetReceiptDtoPaymentMethodEnum = {
    Cash: 'Cash',
    BankTransfer: 'BankTransfer',
    Card: 'Card',
    Mobile: 'Mobile'
} as const;
export type GetReceiptDtoPaymentMethodEnum = typeof GetReceiptDtoPaymentMethodEnum[keyof typeof GetReceiptDtoPaymentMethodEnum];


/**
 * Check if a given object implements the GetReceiptDto interface.
 */
export function instanceOfGetReceiptDto(value: object): value is GetReceiptDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('fiscalized' in value) || value['fiscalized'] === undefined) return false;
    return true;
}

export function GetReceiptDtoFromJSON(json: any): GetReceiptDto {
    return GetReceiptDtoFromJSONTyped(json, false);
}

export function GetReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReceiptDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'receiptDate': json['receiptDate'] == null ? undefined : (new Date(json['receiptDate'])),
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'receiptPositions': json['receiptPositions'] == null ? undefined : ((json['receiptPositions'] as Array<any>).map(GetReceiptPositionDtoFromJSON)),
        'fiscalized': json['fiscalized'],
        'efiscalJws': json['efiscalJws'] == null ? undefined : json['efiscalJws'],
        'efiscalPmno': json['efiscalPmno'] == null ? undefined : json['efiscalPmno'],
        'efiscalVisualizationBase64': json['efiscalVisualizationBase64'] == null ? undefined : json['efiscalVisualizationBase64'],
        'efiscalReceivedAt': json['efiscalReceivedAt'] == null ? undefined : (new Date(json['efiscalReceivedAt'])),
        'printerUid': json['printerUid'] == null ? undefined : json['printerUid'],
        'jpkId': json['jpkId'] == null ? undefined : json['jpkId'],
        'creator': json['creator'] == null ? undefined : GetUserDtoFromJSON(json['creator']),
        'printerJpkDocumentId': json['printerJpkDocumentId'] == null ? undefined : json['printerJpkDocumentId'],
    };
}

export function GetReceiptDtoToJSON(value?: GetReceiptDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'receiptType': value['receiptType'],
        'receiptDate': value['receiptDate'] == null ? undefined : ((value['receiptDate'] as any).toISOString()),
        'amountGross': value['amountGross'],
        'paymentMethod': value['paymentMethod'],
        'examId': value['examId'],
        'exam': GetExamDtoToJSON(value['exam']),
        'receiptPositions': value['receiptPositions'] == null ? undefined : ((value['receiptPositions'] as Array<any>).map(GetReceiptPositionDtoToJSON)),
        'fiscalized': value['fiscalized'],
        'efiscalJws': value['efiscalJws'],
        'efiscalPmno': value['efiscalPmno'],
        'efiscalVisualizationBase64': value['efiscalVisualizationBase64'],
        'efiscalReceivedAt': value['efiscalReceivedAt'] == null ? undefined : ((value['efiscalReceivedAt'] as any).toISOString()),
        'printerUid': value['printerUid'],
        'jpkId': value['jpkId'],
        'creator': GetUserDtoToJSON(value['creator']),
        'printerJpkDocumentId': value['printerJpkDocumentId'],
    };
}

